var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcUserSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 3.25C3.80964 3.25 3.25 3.80964 3.25 4.5V19.5C3.25 20.1904 3.80964 20.75 4.5 20.75H19.5C20.1904 20.75 20.75 20.1904 20.75 19.5V4.5C20.75 3.80964 20.1904 3.25 19.5 3.25H4.5ZM1.75 4.5C1.75 2.98122 2.98122 1.75 4.5 1.75H19.5C21.0188 1.75 22.25 2.98122 22.25 4.5V19.5C22.25 21.0188 21.0188 22.25 19.5 22.25H4.5C2.98122 22.25 1.75 21.0188 1.75 19.5V4.5Z",
    fill: "#76B72A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9915 7.75C11.0221 7.75 10.238 8.53451 10.238 9.5C10.238 10.4655 11.0221 11.25 11.9915 11.25C12.961 11.25 13.7451 10.4655 13.7451 9.5C13.7451 8.53452 12.961 7.75 11.9915 7.75ZM8.73797 9.5C8.73797 7.70407 10.1957 6.25 11.9915 6.25C13.7874 6.25 15.2451 7.70406 15.2451 9.5C15.2451 11.2959 13.7874 12.75 11.9915 12.75C10.1957 12.75 8.73797 11.2959 8.73797 9.5ZM15.9485 17.5083C13.9023 15.2881 10.0929 15.3703 8.04246 17.5179C7.75642 17.8175 7.28168 17.8285 6.98209 17.5425C6.68249 17.2564 6.6715 16.7817 6.95754 16.4821C9.57054 13.7453 14.3841 13.5975 17.0515 16.4917C17.3322 16.7963 17.3129 17.2708 17.0083 17.5515C16.7037 17.8322 16.2292 17.8129 15.9485 17.5083Z",
    fill: "#76B72A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUserSquare);
export default __webpack_public_path__ + "static/media/ic-user-square.e45a69d83d78daf13233a6fb9cb3de0c.svg";
export { ForwardRef as ReactComponent };